var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9977 2.5C16.8852 2.5 17.7039 2.96875 18.1539 3.7375L31.6539 26.7375C32.1102 27.5125 32.1102 28.4688 31.6664 29.2437C31.2227 30.0187 30.3914 30.5 29.4977 30.5H2.49769C1.60394 30.5 0.772693 30.0187 0.328943 29.2437C-0.114807 28.4688 -0.108557 27.5062 0.341443 26.7375L13.8414 3.7375C14.2914 2.96875 15.1102 2.5 15.9977 2.5ZM15.9977 10.5C15.1664 10.5 14.4977 11.1687 14.4977 12V19C14.4977 19.8312 15.1664 20.5 15.9977 20.5C16.8289 20.5 17.4977 19.8312 17.4977 19V12C17.4977 11.1687 16.8289 10.5 15.9977 10.5ZM17.9977 24.5C17.9977 23.9696 17.787 23.4609 17.4119 23.0858C17.0368 22.7107 16.5281 22.5 15.9977 22.5C15.4673 22.5 14.9586 22.7107 14.5835 23.0858C14.2084 23.4609 13.9977 23.9696 13.9977 24.5C13.9977 25.0304 14.2084 25.5391 14.5835 25.9142C14.9586 26.2893 15.4673 26.5 15.9977 26.5C16.5281 26.5 17.0368 26.2893 17.4119 25.9142C17.787 25.5391 17.9977 25.0304 17.9977 24.5Z",
    fill: "#662D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarning);
export default __webpack_public_path__ + "static/media/triangle_warning.ee01417b2bc55eb8dc572db9ec4fba9d.svg";
export { ForwardRef as ReactComponent };